export const DEVICE_CODE = {
  CONCOX: {
    X3: 1002,
    JC400_W: 1003,
    LL301: 1004,
    AT4: 1005,
    JC400_D: 1006,
    LL303: 1008,
    JC261: 1009,
    JC400_C: 1010,
    WANWAY_G19S: 1012,
  },
  TELTONIKA: {
    FMB920: 2001,
    FMB130: 2002,
    FMB125: 2005,
    FMB003: 2007,
    FMB140: 2011,
    FMB930: 2012,
    FMB001: 2013,
    FMB150: 2014,
    FMB202: 2015,
  },
  BSJ: {
    GH03T: 6001,
    EH13: 6002,
    MDVR: 6003,
    MDVR08: 6004,
    ES803: 6005,
  },
  FLESPI_HOWEN: {
    ME3204: 11009,
    ME3108: 11006,
  },
  VSS_HOWEN: {
    ME3204: 11009,
    ME3108: 11006,
    ME4002: 12001,
  },
}

export const DEVICE_CODE_LIST = {
  CONCOX: [
    DEVICE_CODE.CONCOX.X3,
    DEVICE_CODE.CONCOX.JC400_W,
    DEVICE_CODE.CONCOX.LL301,
    DEVICE_CODE.CONCOX.AT4,
    DEVICE_CODE.CONCOX.JC400_D,
    DEVICE_CODE.CONCOX.LL303,
    DEVICE_CODE.CONCOX.JC261,
    DEVICE_CODE.CONCOX.JC400_C,
    DEVICE_CODE.CONCOX.WANWAY_G19S,
  ],
  CONCOX_CAMERA: [
    DEVICE_CODE.CONCOX.JC400_W,
    DEVICE_CODE.CONCOX.JC400_D,
    DEVICE_CODE.CONCOX.JC400_C,
    DEVICE_CODE.CONCOX.JC261,
  ],
  TELTONIKA: [
    DEVICE_CODE.TELTONIKA.FMB001,
    DEVICE_CODE.TELTONIKA.FMB003,
    DEVICE_CODE.TELTONIKA.FMB125,
    DEVICE_CODE.TELTONIKA.FMB130,
    DEVICE_CODE.TELTONIKA.FMB140,
    DEVICE_CODE.TELTONIKA.FMB150,
    DEVICE_CODE.TELTONIKA.FMB202,
    DEVICE_CODE.TELTONIKA.FMB920,
    DEVICE_CODE.TELTONIKA.FMB930,
  ],
  BSJ: [
    DEVICE_CODE.BSJ.GH03T,
    DEVICE_CODE.BSJ.EH13,
    DEVICE_CODE.BSJ.MDVR,
    DEVICE_CODE.BSJ.MDVR08,
    DEVICE_CODE.BSJ.ES803,
  ],
  BSJ_4_CHANNELS: [DEVICE_CODE.BSJ.GH03T, DEVICE_CODE.BSJ.EH13],
  BSJ_8_CHANNELS: [DEVICE_CODE.BSJ.MDVR, DEVICE_CODE.BSJ.MDVR08],
  VSS_HOWEN: [
    DEVICE_CODE.VSS_HOWEN.ME3204,
    DEVICE_CODE.VSS_HOWEN.ME3108,
    DEVICE_CODE.VSS_HOWEN.ME4002,
  ],
  FLESPI_HOWEN: [DEVICE_CODE.FLESPI_HOWEN.ME3204, DEVICE_CODE.FLESPI_HOWEN.ME3108],
}
